import { createGlobalStyle } from "styled-components";
import { primaryColor } from "../config";

const GlobalStyles = createGlobalStyle`
  body{background-color:#F1F2F4 !important}
.app-default, body {
    background-color: #F1F2F4 !important;
}
    [data-kt-app-sidebar-minimize=on] .app-sidebar-toggle .rotate-180{transform: rotateZ(180deg);   transition: transform .3s ease;}
.ant-breadcrumb ol{align-items:center}

.cus-table .ant-table-thead tr th {
    background-color: #F0ECF9 !important;
    color: #181C32 !important;
    font-weight: 700 !important;
}
.ant-table {
    font-size: 13px !important;
}
.ant-pagination .ant-pagination-item-active {
    font-weight: 600;
    background-color: #f45b68;
    border-color: #f45b68;
}
  .ant-pagination .ant-pagination-item-active a{color:#fff !important}
        .ant-pagination .ant-pagination-options{
          margin-left:auto;

          .ant-select-selector {
               border: 1px solid #f4f4f4;
              background: #f4f4f4;
              .ant-select-selection-item{
                font-size: 13px;
                font-weight: 500;
                font-family: Inter;
            }
        }
  }

  .ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    color: rgba(0, 0, 0, 0.88);
    font-weight: 600;
    background-color: #f45b6814;
}
 .ant-dropdown-menu-title-content{display:flex;align-items:center}
 .ant-breadcrumb ol{align-items: center !importnant;}
.ant-table-wrapper .ant-table-tbody >tr >th, .ant-table-wrapper .ant-table-tbody >tr >td {
    border-bottom: 1px dashed #ebe5e5;
}
.ant-modal .ant-modal-content{
  padding:0;
  .ant-modal-header {
      padding: 1.75rem 1.75rem;
      margin-bottom:0;
      border-bottom: 1px dashed #ddd;
      }
  .ant-modal-body{
        padding: 1.75rem 1.75rem;
  }
  .ant-modal-footer{
        padding: 1rem 1.75rem;
      border-top: 1px dashed #ddd;
      margin-top:0;
  }
}

.ant-table-wrapper .ant-table-ping-left:not(.ant-table-has-fix-left) .ant-table-container::before {
    box-shadow: none;
}
.ant-table-wrapper .ant-table-ping-right:not(.ant-table-has-fix-right) .ant-table-container::after {
    box-shadow: none;
}

  .custom-logout-modal .ant-modal-content {
      border-radius: 8px;
      padding: 24px;
      animation: fadeInUp 0.8s ease;
      box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  }

  .custom-logout-modal .ant-modal-header {
      border-bottom: none;
  }

  .custom-logout-modal .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
  }

  .custom-logout-modal .ant-btn-primary {
      background-color: #f45b68;
      border-color: #f45b68;
      font-weight: 600;
  }

  .custom-logout-modal .ant-btn-default {
      font-weight: 500;
      color: #666;
  }

  /* Optional fadeIn animation */
  @keyframes fadeInUp {
      from {
          opacity: 0;
          transform: translateY(40px);
      }
      to {
          opacity: 1;
          transform: translateY(0);
      }
  }

  .ant-carousel .slick-prev::after,
  .ant-carousel .slick-next::after,
  .ant-carousel .slick-prev::before,
  .ant-carousel .slick-next::before {
      display: none !important;
      content: '' !important;
  }
.ant-switch .ant-switch-handle {
    top: 4px;
    inset-inline-start: 4px;
}

.ant-menu-light .ant-menu-submenu-selected >.ant-menu-submenu-title, .ant-menu-light>.ant-menu .ant-menu-submenu-selected >.ant-menu-submenu-title {
    color: #232323;
}

.ant-dropdown {
    z-index: 1000;
}

.ant-btn-color-dangerous.ant-btn-variant-solid {
      color: #fff;
      background: #f45b68;
}

.ant-form-item {
    margin-bottom: 14px;
}

  .ant-segmented {
      padding: 4px;
}
`;

export default GlobalStyles;
